import { render, staticRenderFns } from "./csimFormProperties.vue?vue&type=template&id=00022a8d&scoped=true"
import script from "./csimFormProperties.vue?vue&type=script&lang=js"
export * from "./csimFormProperties.vue?vue&type=script&lang=js"
import style0 from "./csimFormProperties.vue?vue&type=style&index=0&id=00022a8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00022a8d",
  null
  
)

export default component.exports